export default __webpack_public_path__ + "static/media/loading-img.b9e80eca.svg";